export type FootballLeague = 'nfl' | 'ncaa'

export function isValidFootballLeague(league: string): league is FootballLeague {
  return league === 'nfl' || league === 'ncaa'
}

enum League {
  ProFootball = 'NFL',
  CollegeFootball = 'NCAA',
  AllianceOfAmericanFootball = 'AAF',
  CanadianFootball = 'CFL',
  UnitedFootballLeague = 'UFL',
}
// TODO: will fix this in a follow up PR with a bunch of type changes
export { League as TempLeagueEnum }

export enum LeagueID {
  ProFootball = 1,
  CollegeFootball = 2,
  AllianceOfAmericanFootball = 4,
  CanadianFootball = 5,
  UFL = 6,
}

export const getLeagueId = (league: League): number | null => {
  const upperCaseLeague = league.toUpperCase()
  if (upperCaseLeague === 'NFL') {
    return LeagueID.ProFootball
  }
  if (upperCaseLeague === 'NCAA') {
    return LeagueID.CollegeFootball
  }
  if (upperCaseLeague === 'UFL') {
    return LeagueID.UFL
  }
  if (upperCaseLeague === 'CFL') {
    return LeagueID.CanadianFootball
  }
  if (upperCaseLeague === 'AAF') {
    return LeagueID.AllianceOfAmericanFootball
  }
  return null
}

export const getLeagueAbbreviation = (leagueId: number): League | null => {
  if (leagueId === LeagueID.ProFootball) {
    return League.ProFootball
  }
  if (leagueId === LeagueID.CollegeFootball) {
    return League.CollegeFootball
  }
  if (leagueId === LeagueID.UFL) {
    return League.UnitedFootballLeague
  }
  if (leagueId === LeagueID.CanadianFootball) {
    return League.CanadianFootball
  }
  if (leagueId === LeagueID.AllianceOfAmericanFootball) {
    return League.AllianceOfAmericanFootball
  }
  return null
}
